/* eslint-disable react/no-array-index-key */
import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TSeoBlockDesktop } from '../models';
import { collectTree } from '../helpers';
import {
    HEADER,
    LINKS_HEIGHT,
    LINKS_ICONS,
    SEARCH_PLACEHOLDER,
    SEARCH_THEME,
    SUBMIT_BUTTON_TEXT,
    SUBMIT_BUTTON_VIEW,
} from '../config';

export const SeoBlock: FC<TSeoBlockDesktop> = ({
    Layout,
    SectionLink,
    Text,
    BlockDesktop,
    header = HEADER,
    links,
    linksColumns = [],
    linksHeight = LINKS_HEIGHT,
    linksIcons = LINKS_ICONS,
    searchPlaceholder = SEARCH_PLACEHOLDER,
    searchTheme = SEARCH_THEME,
    sections,
    styles,
    subSections,
    submitButtonText = SUBMIT_BUTTON_TEXT,
    submitButtonView = SUBMIT_BUTTON_VIEW,
    SearchBar,
    Button,
    SubSection,
    ViewAnalytics,
    viewAnalytics = {},
}) => {
    const tree = collectTree({ links, sections, subSections });

    return (
        <ViewAnalytics analytics={viewAnalytics}>
            <BlockDesktop className={cn(styles.external, styles.seoblock)} notPadded>
                <Layout
                    className={cn(styles.external, styles.block)}
                    data-theme="dark"
                    styler={{ paddingTop: 32, paddingBottom: 32 }}
                >
                    <Text
                        styler={{ marginBottom: 24, marginTop: 0 }}
                        tag="h2"
                        theme="dark"
                        view="small"
                    >
                        {header}
                    </Text>
                    <SearchBar
                        className={cn(
                            styles.external,
                            styles.searchBar,
                            searchTheme === 'dark' && styles.searchBarDark
                        )}
                        classNames={{
                            input: cn(
                                styles.external,
                                searchTheme === 'dark' && styles.searchInputDark
                            ),
                        }}
                        placeholder={searchPlaceholder}
                        styler={{ marginBottom: 24 }}
                    >
                        <Button
                            block
                            className={cn(styles.external, styles.searchButton)}
                            colors="inverted"
                            size="s"
                            type="submit"
                            view={submitButtonView}
                        >
                            {submitButtonText}
                        </Button>
                    </SearchBar>
                    <nav className={styles.nav}>
                        {tree.map((section, idx) => (
                            <div
                                key={section.key}
                                className={styles.section}
                                style={{ flexGrow: linksColumns[idx] ?? 0 }}
                            >
                                <SectionLink
                                    styler={{ marginTop: 0, marginBottom: 12 }}
                                    type="section"
                                    withIcons={linksIcons}
                                >
                                    {section.title}
                                </SectionLink>

                                <div className={styles.sectionGrid} style={{ height: linksHeight }}>
                                    {section.children.map((subSection, subIdx) => (
                                        <SubSection
                                            key={subSection.key ?? subIdx}
                                            subSection={subSection}
                                            withIcons={linksIcons}
                                        />
                                    ))}
                                </div>
                            </div>
                        ))}
                    </nav>
                </Layout>
            </BlockDesktop>
        </ViewAnalytics>
    );
};
